import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GridModalComponent } from '../../core/components/grid/grid.decorators';
import { Grid } from '../../core/components/grid/grid.model';
import { GridModalData } from '../../core/components/grid/modals/grid-modal.service';
import { DataTaskService } from '../../core/services/data-task.service';
import { ModalService } from '../../core/services/modal.service';
import { DocArcService } from '../../services/doc-arc.service';

@GridModalComponent('AddExistingDocArc')
@Component({
  selector: 'tt-add-existing-doc-arc-dialog',
  templateUrl: './add-existing-doc-arc-dialog.component.html',
  styleUrls: ['./add-existing-doc-arc-dialog.component.css']
})
export class AddExistingDocArcDialogComponent {
    public params?: { argtype: string, argvalue: string };

    constructor(@Inject(MAT_DIALOG_DATA) private data: GridModalData, private dialogRef: MatDialogRef<AddExistingDocArcDialogComponent>, private datatask: DataTaskService, private docarc: DocArcService, private modal: ModalService) {
        dialogRef.updateSize('80vw', '80vh');

        if (!!data.loadData?.parameters) {
            let parameters: any = data.loadData.parameters;
            if (parameters instanceof Function) parameters = parameters();
            console.log(parameters);
            this.params = { argtype: parameters.argtype, argvalue: parameters.argvalue }
        }
    }
}
